import { Component, Mixins } from 'vue-property-decorator';
import { mapActions } from 'vuex';
import { namespace } from 'vuex-class';
import { Breadcrumbs as BreadcrumbsLayout } from '@/components/layout';
import SiteMap from '@/components/layout/SiteMap.vue';
import { Yellow as FlexFilter } from '@/components/parts/filter';
import {
  List as OrganizationsList,
  Item as ProgramsItem,
  Items as ProgramsItems,
} from '@/components/parts/catalog/list';
import SelectCount from '@/components/parts/catalog/list/count';
import { Paginator as OrganizationsPaginator } from '@/components/parts/pagination';
import List from '@/pages/mixin-list';
import Nav from '@/pages/mixin-nav';
import Common from '../common';
import Filter from '../filter';
import { Breadcrumbs } from '../types';
import {
  ACTION_FETCH,
  BREADCRUMBS_TEXT,
  BY_PAGE_TEXT,
  IMG_BG_COLOR,
  IMG_BG_SIZE,
  ORGANIZATION_ROUTE,
  PAGE_NUMBER,
  PAGE_TITLE,
  PAGE_SEO_TITLE,
  PAGE_SIZE,
  PAGE_SIZES,
  SITEMAP_TEXT,
  SITEMAP_TITLE,
  STORE_MODULE_NAME,
} from './const';
import createStoreModule from './store';
import { Items, Organization } from './types';

const actions = mapActions(STORE_MODULE_NAME, [ACTION_FETCH]);
const fetch = actions[ACTION_FETCH];
const Organizations = namespace(STORE_MODULE_NAME);

const getPageSize = (value?: string) => value || PAGE_SIZE;

@Component({
  components: {
    BreadcrumbsLayout,
    FlexFilter,
    OrganizationsList,
    OrganizationsPaginator,
    SelectCount,
    SiteMap,
  },
  metaInfo: {
    title: PAGE_SEO_TITLE,
  },
  storeName: STORE_MODULE_NAME,
  storeRegister: createStoreModule,
})
export default class PageOrganizationsList extends Mixins(
  Common,
  List,
  Filter,
  Nav,
) {
  // Bindings
  @Organizations.State items: Items;
  @Organizations.State count: number;
  @Organizations.State page: number;
  @Organizations.State limit: number;

  // Readonly
  readonly imgBgColor = IMG_BG_COLOR;
  readonly imgBgSize = IMG_BG_SIZE;
  readonly title = PAGE_TITLE;
  readonly sitemapTitle = SITEMAP_TITLE;
  readonly sitemapText = SITEMAP_TEXT;
  readonly byPageText = BY_PAGE_TEXT;
  readonly pageSizes = PAGE_SIZES;

  // Computed
  get breadcrumbsExtended(): Breadcrumbs {
    return [...this.breadcrumbs, { text: BREADCRUMBS_TEXT }];
  }

  get localFilterValues() {
    const { filterValues, limit } = this;
    return { ...filterValues, limit };
  }

  get hasError() {
    return this.items === false;
  }

  get hasItems() {
    const { organizations } = this;
    return (
      organizations && Array.isArray(organizations) && organizations.length > 0
    );
  }

  get organizations(): ProgramsItems {
    const { items } = this;
    if (!items) return [];
    return items.map(
      ({ code, contacts, id, logo, name, cop_multi_name }: Organization): ProgramsItem => {
        const text = [(contacts && contacts.address) || ''];
        const result: ProgramsItem = {
          id,
          code,
          text,
          cop_multi_name: cop_multi_name,
          image: {
            small: logo,
            large: logo,
          },
          link: {
            name: ORGANIZATION_ROUTE,
            params: { code, id: String(id) },
          },
          title: name,
        };
        return result;
      },
    );
  }

  get pageLimit() {
    return getPageSize(this.$route.query.limit as any);
  }

  get pageLimits() {
    return this.pageSizes.map((value) => ({ value, text: value }));
  }

  get pagesCount(): number {
    const { count, limit } = this;
    return limit ? Math.ceil(count / limit) : 0;
  }

  // Methods
  async asyncData({ store, route }: any) {
    const query = { ...route.query };
    query.page = query.page || PAGE_NUMBER;
    query.limit = getPageSize(query.limit);
    await fetch.call({ $store: store }, query);
  }
}



// WEBPACK FOOTER //
// ./src/pages/organizations/list/script.ts